/**
 * Common - Footer Newsletter organism
 */
import * as Utils from '../Utils';

const newsletterId = 'footerNewsletter';

let newsletter;

function initNoHead() {
  if (newsletter.length && Utils.getUrlParameter('nohead') === 'true') {
    newsletter.remove();
  }
}

function init() {
  // Save reference to the header element
  newsletter = $(`#${newsletterId}`);

  initNoHead();
}

export {
  init,
};

export default init;



// WEBPACK FOOTER //
// ./js/common/organism/footer-newsletter.js